import React, { useEffect, useState } from "react";

import { getLoggedInUser } from "../helpers/fakebackend_helper";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  const [isDashboard, setIsDashboard] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [isItem, setIsItem] = useState(false);
  const [isListItem, setIsListItem] = useState(false);
  const [isProcurement, setIsProcurement] = useState(false);

  const [isPeople, setIsPeople] = useState(false);
  const [isPaymentReport, setIsPaymentReport] = useState(false);
  const [isSetup, setIsSetup] = useState(false);
  const [isPayment, setIsPayment] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isLogs, setIsLogs] = useState(false);

  const [isPaymentType, setIsPaymentType] = useState(false);
  const [isMenuCategory, setIsMenuCategory] = useState(false);
  const [isMenuItem, setMenuItem] = useState(false);
  const [isSetting, setIsSetting] = useState(false);
  const [isWaiter, setIsWaiter] = useState(false);
  const [isTable, setIsTable] = useState(false);
  const authUser = getLoggedInUser();
  // console.log("authUserr", authUser);
  const userRole = authUser?.user?.roles[0]?.toLowerCase();
  // console.log("🚀 ~ Navdata ~ userRole:", userRole);
  const isSuperAdmin = authUser.user.roles.includes("SuperAdmin");
  // const isSuperAdmin = true;
  // console.log("isSuperAdmin", isSuperAdmin);
  const isAdmin = true;

  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");

    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }

    if (iscurrentState !== "people-management") {
      setIsPeople(false);
    }

    if (iscurrentState !== "PaymentReport") {
      setIsPaymentReport(false);
    }

    if (iscurrentState !== "payment-type") {
      setIsPaymentType(false);
    }
    if (iscurrentState !== "menu-category") {
      setIsMenuCategory(false);
    }
    if (iscurrentState !== "menu-item") {
      setMenuItem(false);
    }

    if (iscurrentState !== "setting") {
      setIsSetting(false);
    }

    if (iscurrentState !== "settings") {
      setIsWaiter(false);
    }
    if (iscurrentState !== "Table") {
      setIsTable(false);
    }
    if (iscurrentState !== "sales-report") {
      setIsSales(false);
    }
    if (iscurrentState !== "logs") {
      setIsLogs(false);
    }
    if (iscurrentState !== "user-management") {
      setIsUser(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isSetup,

    isPeople,

    isPaymentReport,

    isPaymentType,
    isMenuCategory,
    isMenuItem,
    isUser,
    isSetting,
    isWaiter,
    isTable,
    isSales,
    isLogs,
  ]);

  const orgMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    // {
    //   id: "customer",
    //   label: "Customer",
    //   icon: "ri-group-line",
    //   link: "/customer-list",
    //   click: (e) => {
    //     e.preventDefault();
    //     handleMenuClick("customer");
    //   },
    // },

    {
      id: "user-management",
      label: "User Management",
      icon: "ri-group-line",
      link: "/user-management",
      parentId: "user-management",
      click: (e) => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState("user-management");
        updateIconSidebar(e);
      },
      stateVariables: isUser,
      subItems: [
        {
          id: "customer",
          label: "Customers",
          icon: "ri-group-line",
          link: "/customer-list",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("customer");
          },
        },
        {
          id: "customer-type",
          label: "Customer Types",
          icon: "ri-apps-2-line",
          link: "/customer-type",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("customer-type");
          },
        },
        {
          id: "staff",
          label: "Staffs",
          icon: "ri-group-line",
          link: "/staff",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("staff");
          },
        },
        {
          id: "suppliers",
          label: "Suppliers",
          icon: "ri-apps-2-line",
          link: "/suppliers",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("suppliers");
          },
        },
      ],
    },

    {
      id: "product-management",
      label: "Inventory Management",
      icon: "ri-restaurant-2-line",
      link: "/product-management",
      parentId: "product-management",
      click: (e) => {
        e.preventDefault();
        setIsItem(!isItem);
        setIscurrentState("product-management");
        updateIconSidebar(e);
      },
      stateVariables: isItem,
      subItems: [
        {
          id: "menu-category",
          label: "Category",
          icon: "bx bx-category",
          link: "/category-list",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("menu-category");
          },
        },
        {
          id: "menu-item",
          label: "Products",
          icon: "ri-apps-2-line",
          link: "/menu-item",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("menu-item");
          },
        },
        {
          id: "receipe-management",
          label: "Receipe Management",
          icon: "bx bx-bowl-hot",
          link: "/receipe-management",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("receipe-management");
          },
        },
        {
          id: "purchase",
          label: "Purchases",
          icon: "ri-apps-2-line",
          link: "/purchase",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("purchase");
          },
        },
      ],
    },

    {
      id: "order-management",
      label: "Order Management",
      icon: "ri-shopping-bag-line",
      link: "/order-management",
      parentId: "order-management",
      click: (e) => {
        e.preventDefault();
        setIsListItem(!isListItem);
        setIscurrentState("order-management");
        updateIconSidebar(e);
      },
      stateVariables: isListItem,
      subItems: [
        //order list
        {
          id: "order",
          label: "Orders",
          icon: "bx bx-category",
          link: "/order",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("order");
          },
        },

        //order details
        {
          id: "order-detail",
          label: "Orders Details",
          icon: "ri-apps-2-line",
          link: "/order-detail",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("order-detail");
          },
        },
      ],
    },
    // {
    //   id: "procurement",
    //   label: "Procurement",
    //   icon: "ri-shopping-bag-line",
    //   link: "/procurement",
    //   parentId: "procurement",
    //   click: (e) => {
    //     e.preventDefault();
    //     setIsProcurement(!isProcurement);
    //     setIscurrentState("procurement");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isProcurement,
    //   subItems: [

    //   ],
    // },

    {
      id: "payment-record",
      label: "Payment Records",
      icon: "bx bxs-report",
      link: "/payment-record",
      parentId: "payment-record",
      click: (e) => {
        e.preventDefault();
        setIsPayment(!isPayment);
        setIscurrentState("payment-record");
        updateIconSidebar(e);
      },
      stateVariables: isPayment,
      subItems: [
        {
          id: "Payment statement",
          label: "Payment Statement",
          link: "/payment/statement",
          parentId: "payment-report",
        },
        {
          id: "Payment Day book",
          label: "Day Book",
          link: "/day-book",
          parentId: "payment-report",
        },
      ],
    },
    {
      id: "sales-report",
      label: "Reports",
      icon: "bx bxs-report",
      link: "/sales-reports",
      parentId: "sales-report",
      click: (e) => {
        e.preventDefault();
        setIsSales(!isSales);
        setIscurrentState("sales-report");
        updateIconSidebar(e);
      },
      stateVariables: isSales,
      subItems: [
        {
          id: "Credit Summary",
          label: "Credit Summary",
          link: "/credit-logs/summary",
          parentId: "sales-report",
        },
        {
          id: "sales-reports",
          label: "Sales Report",
          icon: "ri-apps-2-line",
          link: "/sales-report",
        },
        {
          id: "sales-report-wise",
          label: "Stock Summary",
          icon: "ri-apps-2-line",
          link: "/sales-report/wise",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("sales-report-wise");
          },
        },
        {
          id: "return-bill-report",
          label: "Return Bill Report",
          icon: "ri-apps-2-line",
          link: "/return-bill-report",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("return-bill-report");
          },
        },
        {
          id: "transaction-report",
          label: "Transcation Report",
          icon: "ri-apps-2-line",
          link: "/transaction/report",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("transaction-report");
          },
        },
      ],
    },

    {
      id: "logs",
      label: "Logs",
      icon: "bx bxs-report",
      link: "/logs",
      parentId: "logs",
      click: (e) => {
        e.preventDefault();
        setIsLogs(!isLogs);
        setIscurrentState("logs");
        updateIconSidebar(e);
      },
      stateVariables: isLogs,
      subItems: [
        {
          id: "Complimentry Logs",
          label: "Complimentry logs",
          link: "/complimentry-logs",
          parentId: "logs",
        },
        {
          id: "Day Book Logs",
          label: "Day Book logs",
          link: "/logs/day-book",
          parentId: "logs",
        },
      ],
    },
    {
      id: "Setup",
      label: "System Setup",
      icon: "ri-settings-3-line",
      link: "/appointment",
      parentId: "appointment",
      click: (e) => {
        e.preventDefault();
        setIsSetup(!isSetup);
        setIscurrentState("Setup");
        updateIconSidebar(e);
      },
      stateVariables: isSetup,
      subItems: [
        {
          id: "payment-type",
          label: "Payment Types",
          icon: "ri-apps-2-line",
          link: "/payment-type",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("payment-type");
          },
        },
        {
          id: "Section",
          label: "Section",
          icon: "ri-group-line",
          link: "/section",
          click: (e) => {
            e.preventDefault();
            setIsDashboard(!isSection);
            setIscurrentState("Section");
          },
        },
        {
          id: "Table",
          label: "Table",
          icon: "ri-restaurant-2-line",
          link: "/table",
          click: (e) => {
            e.preventDefault();
            setIsDashboard(!isTable);
            setIscurrentState("Table");
          },
        },
        {
          id: "unit",
          label: "Unit",
          icon: "ri-apps-2-line",
          link: "/unit",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("unit");
          },
        },
        {
          id: "unitConversion",
          label: "Unit Conversion",
          icon: "ri-apps-2-line",
          link: "/unit-conversion",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("unitConversion");
          },
        },
        {
          id: "cost-center",
          label: "Cost Center",
          icon: "ri-apps-2-line",
          link: "/cost-center",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("cost-center");
          },
        },
        {
          id: "discount-center",
          label: "Discount Center",
          icon: "ri-apps-2-line",
          link: "/discount-center",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("discount-center");
          },
        },
        {
          id: "feature-settings",
          label: "Features Settings",
          icon: "ri-apps-2-line",
          link: "/feature-settings",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("feature-settings");
          },
        },
      ],
    },
    {
      id: "setting",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/setting",
      parentId: "setting",
      click: (e) => {
        e.preventDefault();
        setIsSetting(!isSetting);
        setIscurrentState("setting");
        updateIconSidebar(e);
      },
      stateVariables: isSetting,
      subItems: [
        {
          id: "generate-print-token",
          label: "Generate print token",
          icon: "ri-apps-2-line",
          link: "/generate-print-token",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("generate-print-token");
          },
        },
        {
          id: "clear-data",
          label: "Clear Data",
          icon: "ri-apps-2-line",
          link: "/clear-data",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("clear-data");
          },
        },
        {
          id: "download-template",
          label: "Download Template(Menu)",
          icon: "ri-apps-2-line",
          link: "/download-template",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("download-template");
          },
        },
        {
          id: "import-template",
          label: "Import Template(Menu)",
          icon: "ri-apps-2-line",
          link: "/import-template",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("import-template");
          },
        },
      ],
    },
  ];

  const superAdminItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    {
      id: "tenant",
      label: "Org Tenant",
      icon: "ri-apps-2-line",
      link: "/tenant",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("tenant");
      },
    },
    {
      id: "email-config",
      label: "Email Configuration",
      icon: "ri-mail-line",
      link: "/email-configuration",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("email-config");
      },
    },
    {
      id: "daily-stat-report",
      label: "Daily Stat Report",
      icon: "ri-file-chart-line",
      link: "/daily-stat-report",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("daily-stat-report");
      },
    },
    {
      id: "kot-logs-request",
      label: "KOT Logs",
      icon: "ri-printer-line",
      link: "/kot-logs-request",
      click: (e) => {
        e.preventDefault();
        handleMenuClick("kot-logs-request");
      },
    },
  ];

  const cashierMenuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "Dashboard",
      label: "Dashboard",
      icon: "ri-dashboard-line",
      link: "/dashboard",
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
      },
    },

    // {
    //   id: "customer",
    //   label: "Customer",
    //   icon: "ri-group-line",
    //   link: "/customer-list",
    //   click: (e) => {
    //     e.preventDefault();
    //     handleMenuClick("customer");
    //   },
    // },

    {
      id: "user-management",
      label: "User Management",
      icon: "ri-group-line",
      link: "/user-management",
      parentId: "user-management",
      click: (e) => {
        e.preventDefault();
        setIsUser(!isUser);
        setIscurrentState("user-management");
        updateIconSidebar(e);
      },
      stateVariables: isUser,
      subItems: [
        {
          id: "customer",
          label: "Customer",
          icon: "ri-group-line",
          link: "/customer-list",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("customer");
          },
        },
        {
          id: "customer-type",
          label: "Customer Type",
          icon: "ri-apps-2-line",
          link: "/customer-type",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("customer-type");
          },
        },
        {
          id: "staff",
          label: "Staff",
          icon: "ri-group-line",
          link: "/staff",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("staff");
          },
        },
        {
          id: "suppliers",
          label: "Suppliers",
          icon: "ri-apps-2-line",
          link: "/suppliers",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("suppliers");
          },
        },
      ],
    },

    {
      id: "product-management",
      label: "Inventory Management",
      icon: "ri-restaurant-2-line",
      link: "/product-management",
      parentId: "product-management",
      click: (e) => {
        e.preventDefault();
        setIsItem(!isItem);
        setIscurrentState("product-management");
        updateIconSidebar(e);
      },
      stateVariables: isItem,
      subItems: [
        {
          id: "menu-category",
          label: "Category",
          icon: "bx bx-category",
          link: "/category-list",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("menu-category");
          },
        },
        {
          id: "menu-item",
          label: "Products",
          icon: "ri-apps-2-line",
          link: "/menu-item",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("menu-item");
          },
        },
        {
          id: "receipe-management",
          label: "Receipe Management",
          icon: "bx bx-bowl-hot",
          link: "/receipe-management",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("receipe-management");
          },
        },
        {
          id: "purchase",
          label: "Purchases",
          icon: "ri-apps-2-line",
          link: "/purchase",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("purchase");
          },
        },
      ],
    },

    {
      id: "order-management",
      label: "Order Management",
      icon: "ri-shopping-bag-line",
      link: "/order-management",
      parentId: "order-management",
      click: (e) => {
        e.preventDefault();
        setIsListItem(!isListItem);
        setIscurrentState("order-management");
        updateIconSidebar(e);
      },
      stateVariables: isListItem,
      subItems: [
        //order list
        {
          id: "order",
          label: "Orders",
          icon: "bx bx-category",
          link: "/order",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("order");
          },
        },

        //order details
        {
          id: "order-detail",
          label: "Orders Details",
          icon: "ri-apps-2-line",
          link: "/order-detail",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("order-detail");
          },
        },
      ],
    },
    // {
    //   id: "procurement",
    //   label: "Procurement",
    //   icon: "ri-shopping-bag-line",
    //   link: "/procurement",
    //   parentId: "procurement",
    //   click: (e) => {
    //     e.preventDefault();
    //     setIsProcurement(!isProcurement);
    //     setIscurrentState("procurement");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isProcurement,
    //   subItems: [

    //   ],
    // },

    {
      id: "payment-record",
      label: "Payment Records",
      icon: "bx bxs-report",
      link: "/payment-record",
      parentId: "payment-record",
      click: (e) => {
        e.preventDefault();
        setIsPayment(!isPayment);
        setIscurrentState("payment-record");
        updateIconSidebar(e);
      },
      stateVariables: isPayment,
      subItems: [
        {
          id: "payment-type",
          label: "Payment Types",
          icon: "ri-apps-2-line",
          link: "/payment-type",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("payment-type");
          },
        },

        {
          id: "Payment statement",
          label: "Payment Statement",
          link: "/payment/statement",
          parentId: "payment-report",
        },
        {
          id: "Payment Day book",
          label: "Day Book",
          link: "/day-book",
          parentId: "payment-report",
        },
      ],
    },
    {
      id: "sales-report",
      label: "Sales report",
      icon: "bx bxs-report",
      link: "/sales-report",
      parentId: "sales-report",
      click: (e) => {
        e.preventDefault();
        setIsSales(!isSales);
        setIscurrentState("sales-report");
        updateIconSidebar(e);
      },
      stateVariables: isSales,
      subItems: [
        {
          id: "Credit Summary",
          label: "Credit Summary",
          link: "/credit-logs/summary",
          parentId: "sales-report",
        },
        {
          id: "sales-reports",
          label: "Sales Report",
          icon: "ri-apps-2-line",
          link: "/sales-report",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("sales-report");
          },
        },
        {
          id: "sales-report-wise",
          label: "Stock Summary",
          icon: "ri-apps-2-line",
          link: "/sales-report/wise",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("sales-report-wise");
          },
        },
        {
          id: "return-bill-report",
          label: "Return Bill Report",
          icon: "ri-apps-2-line",
          link: "/return-bill-report",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("return-bill-report");
          },
        },
      ],
    },

    {
      id: "logs",
      label: "Logs",
      icon: "bx bxs-report",
      link: "/logs",
      parentId: "logs",
      click: (e) => {
        e.preventDefault();
        setIsLogs(!isLogs);
        setIscurrentState("logs");
        updateIconSidebar(e);
      },
      stateVariables: isLogs,
      subItems: [
        {
          id: "Complimentry Logs",
          label: "Complimentry logs",
          link: "/complimentry-logs",
          parentId: "logs",
        },
        {
          id: "Day Book Logs",
          label: "Day Book logs",
          link: "/logs/day-book",
          parentId: "logs",
        },
      ],
    },
    {
      id: "Setup",
      label: "System Setup",
      icon: "ri-settings-3-line",
      link: "/appointment",
      parentId: "appointment",
      click: (e) => {
        e.preventDefault();
        setIsSetup(!isSetup);
        setIscurrentState("Setup");
        updateIconSidebar(e);
      },
      stateVariables: isSetup,
      subItems: [
        {
          id: "Section",
          label: "Section",
          icon: "ri-group-line",
          link: "/section",
          click: (e) => {
            e.preventDefault();
            setIsDashboard(!isSection);
            setIscurrentState("Section");
          },
        },
        {
          id: "Table",
          label: "Table",
          icon: "ri-restaurant-2-line",
          link: "/table",
          click: (e) => {
            e.preventDefault();
            setIsDashboard(!isTable);
            setIscurrentState("Table");
          },
        },
        {
          id: "unit",
          label: "Unit",
          icon: "ri-apps-2-line",
          link: "/unit",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("unit");
          },
        },
        {
          id: "unitConversion",
          label: "Unit Conversion",
          icon: "ri-apps-2-line",
          link: "/unit-conversion",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("unitConversion");
          },
        },
        {
          id: "cost-center",
          label: "Cost Center",
          icon: "ri-apps-2-line",
          link: "/cost-center",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("cost-center");
          },
        },
      ],
    },
    {
      id: "setting",
      label: "Settings",
      icon: "ri-settings-3-line",
      link: "/setting",
      parentId: "setting",
      click: (e) => {
        e.preventDefault();
        setIsSetting(!isSetting);
        setIscurrentState("setting");
        updateIconSidebar(e);
      },
      stateVariables: isSetting,
      subItems: [
        {
          id: "generate-print-token",
          label: "Generate print token",
          icon: "ri-apps-2-line",
          link: "/generate-print-token",
          click: (e) => {
            e.preventDefault();
            handleMenuClick("generate-print-token");
          },
        },
      ],
    },
  ];
  let filteredMenuItems;

  if (userRole === "superadmin") {
    filteredMenuItems = superAdminItems;
  } else if (userRole === "cashier") {
    filteredMenuItems = cashierMenuItems;
  } else {
    filteredMenuItems = orgMenuItems;
  }

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};

export default Navdata;
